import { useEffect, useState } from "react";

// Phone layout threshold: phones and portrait tablets (< 1024 px). Anything wider is the desktop portal, unchanged.
export const PHONE_QUERY = "(max-width: 1023px)";

const mq = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(PHONE_QUERY) : null);

export function useIsPhone() {
  const [phone, setPhone] = useState(() => !!mq()?.matches);
  useEffect(() => {
    const m = mq();
    if (!m) return undefined;
    const handler = (e) => setPhone(e.matches);
    m.addEventListener("change", handler);
    return () => m.removeEventListener("change", handler);
  }, []);
  return phone;
}

export const isPhoneNow = () => !!mq()?.matches;
